// extracted by mini-css-extract-plugin
export const banner = "banner-module--banner--2OcJW";